/** Minimum password length enforced client-side (must match Better Auth server config). */
export const MIN_PASSWORD_LENGTH = 8;

/** Maximum password length — matches Better Auth default (128) and vb-server set-password schema. */
export const MAX_PASSWORD_LENGTH = 128;
